import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import Chip, { LabelChipProps } from 'modules/core/components/Filter/base/Chip'
import ClearValue from 'modules/core/components/Filter/base/ClearValue'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import useFilter from 'modules/core/components/Filter/base/useFilter'

import { LEAVE_CHANGE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'

import './index.styles.css'
type Option = {
  label: string
  value: string[]
  component?: React.ReactNode
  activeFilters?: number | undefined
}

type Props = LabelChipProps & {
  header?: React.ReactNode
  footer?: React.ReactNode
  options: { [key: string]: Option[] }
  value?: string[]
  selectedOption?: Option
  onValueChange: (value: string[]) => void
  onToggle?: (open: boolean) => void
  defaultOpen?: boolean
  noFooter?: boolean
  fullWidth?: boolean
  onClose?: () => void
  isOpen?: boolean
  handleFilterVisibility?: (value: boolean) => void
}

function Body({ options }: { options: { [key: string]: Option[] } }) {
  const { value: filterValue, onValueChange } = useFilter<string[]>()
  const nodes = Object.entries(options).map(([title_label, opts]) => (
    <Box key={title_label} padding="s12">
      <Text.Normal size="200" color="grey600" ellipsis>
        {title_label}
      </Text.Normal>
      {opts.map(({ label, value, component, activeFilters }, index) => (
        <button key={index} className={'GroupedChoice_option'} onClick={() => onValueChange(value)}>
          {component ?? (
            <Box flexDirection="row" gap="s6">
              {activeFilters && activeFilters > 0 ? (
                <Tag size="normal" type="viridian">
                  {activeFilters}
                </Tag>
              ) : null}

              <Text.Normal size="300" color="grey800" ellipsis>
                {label}
              </Text.Normal>
            </Box>
          )}
          {filterValue?.[0]?.split(',') &&
            JSON.stringify(filterValue[0].split(',')) === JSON.stringify(value) && (
              <Icon.Medium icon="check" color="viridian1200" />
            )}
        </button>
      ))}
    </Box>
  ))

  return <Box flexDirection="column">{nodes}</Box>
}

export function GroupedChoice({
  header,
  label,
  options,
  value,
  selectedOption,
  onValueChange,
  onToggle,
  defaultOpen = false,
  fullWidth,
  onClose,
  isOpen,
  handleFilterVisibility,
}: Props) {
  const flatOptions = Object.values(options).flat()
  const { value: selectedValue, label: activeLabel } = selectedOption || {
    value,
    label: flatOptions
      .find((option) => option.value.join(',') === value?.join(','))
      ?.label.replace(/ \(\d+\)$/, ''),
  }

  const customLeaveOption = flatOptions.find(
    (option) => option.value.includes(LEAVE_CHANGE_TYPES.custom_leave) && option.value.length === 1
  )

  const customLeaveOptionsActive = customLeaveOption?.activeFilters
  const active = (customLeaveOptionsActive && customLeaveOptionsActive > 0) || !!selectedValue?.[0]

  return (
    <Provider
      value={selectedValue}
      onValueChange={onValueChange}
      defaultOpen={!!defaultOpen}
      onClose={onClose}
      open={isOpen}
      setOpen={handleFilterVisibility}
    >
      <Chip.Toggler
        active={!!active}
        label={label}
        activeLabel={activeLabel}
        onToggle={onToggle}
        fullWidth={fullWidth}
      />
      {!!Object.keys(options).length && (
        <Content
          onClose={onClose}
          header={header}
          body={<Body options={options} />}
          footer={<ClearValue />}
        />
      )}
    </Provider>
  )
}
